export default class ControlTypeConst {

    static CTA = 'tipocontrol-a'
    static CTBUTTON = 'tipocontrol-btn'
    static CTTGLBUTTON = 'tipocontrol-tglbtn'
    static CTSPLITBUTTON = 'tipocontrol-splitbtn'
    static CTCALENDAR = 'tipocontrol-cld'
    static CTCRUD = 'tipocontrol-crudtbl'
    static CTCHECKBOX = 'tipocontrol-checkb'
    static CTCHIP = 'tipocontrol-chip'
    static CTDIVIDER = 'tipocontrol-divid'
    static CTDROPDOWN = 'tipocontrol-dropwn'
    static CTDROPDOWNCASCADE = 'tipocontrol-dropwncascade'
    static CTIMAGE = 'tipocontrol-img'
    static CTINPUTSWITCH = 'tipocontrol-inpsw'
    static CTINPUTTEXT = 'tipocontrol-inptx'
    static CTINPUTNUMBER = 'tipocontrol-inumb'
    static CTLABEL = 'tipocontrol-lbl'
    static CTMULTISELECT = 'tipocontrol-mltsel'
    static CTPANEL = 'tipocontrol-pnl'
    static CTRADIOBUTTON = 'tipocontrol-radbut'
    static CTSPAN = 'tipocontrol-span'
    static CTTABPANEL = 'tipocontrol-tabpnl'
    static CTTABVIEW = 'tipocontrol-tabv'
    static CTTAG = 'tipocontrol-tag'
    static CTSCROLLPANEL = 'tipocontrol-scrollp'
    static CTTOOLBAR = 'tipocontrol-toolb'
    static CTTEXAREA = 'tipocontrol-txta'
    static CTRATING='tipocontrol-rat'
    static CTTIMELINE='tipocontrol-tlin'
    static CTAVATAR='tipocontrol-avt'
    static CTEM = 'tipocontrol-em'
    static CTH1 = 'tipocontrol-h1'
    static CTH2 = 'tipocontrol-h2'
    static CTH3 = 'tipocontrol-h3'
    static CTH4 = 'tipocontrol-h4'
    static CTH5 = 'tipocontrol-h5'
    static CTH6 = 'tipocontrol-h6'
    static CTHR = 'tipocontrol-hr'
    static CTI = 'tipocontrol-i'
    static CTB = 'tipocontrol-b'
    static CTBR = 'tipocontrol-br'
    static CTSMALL = 'tipocontrol-small'
    static CTP= 'tipocontrol-p'
    static CTCARD = 'tipocontrol-card'
    static CTSTRONG = 'tipocontrol-strong'
    static CTDIV = 'tipocontrol-div'
    
    static CTMENU = 'tipocontrol-menu'
    static CTMENUITEM= 'tipocontrol-menui'
    static CTFIELDSET= 'tipocontrol-fieldset'
    static CTLOOKUPEDITOR='tipocontrol-lookupedit'
    static CTSEARCH='tipocontrol-search'
    static CTLAYOUT_PNL_FOOTER='layouttemp-pnl-footer'
    static CTLAYOUT_PNL_HEADER='layouttemp-pnl-header'
    static CTLAYOUT_PNL_ICON='layouttemp-pnl-icon'
    static CTDATATABLE='tipocontrol-dtable'
    static CTCOLUMN='tipocontrol-col'
    static CTINPUT='tipocontrol-input'
    static CTIFRAME='tipocontrol-ifr'
    static CTDATAVIEW='tipocontrol-dview'
    static CTPASSWORD = 'tipocontrol-pwd'
    static CTBADGE = 'tipocontrol-badge'
    static CTKNOB = 'tipocontrol-knob'
    static CTEDITOR = 'tipocontrol-editor'
    static CTCOLORPICKER = 'tipocontrol-colorpicker'
    static CTDIALOG = 'tipocontrol-dialog'
    static CTAUTOCOMPLETE = 'tipocontrol-autocomp'
    static CTCHART = 'tipocontrol-chart'
    static CTCHARTCIRC = 'tipocontrol-chartcirc'
    
    static CTLAYOUT_SPLITBTN_MENU= 'layouttemp-splitbtn-menu'
    static CTLAYOUT_DVIEW_FOOTER='layouttemp-dview-footer'
    static CTLAYOUT_DVIEW_HEADER='layouttemp-dview-header'
    static CTLAYOUT_DVIEW_PAGINATORSTART='layouttemp-dview-paginatorstart'
    static CTLAYOUT_DVIEW_PAGINATOREND='layouttemp-dview-paginatorend'
    static CTLAYOUT_DVIEW_EMPTY='layouttemp-dview-empty'
    static CTLAYOUT_DVIEW_LIST='layouttemp-dview-list'
    static CTLAYOUT_DVIEW_GRID='layouttemp-dview-grid'

    static CTLAYOUT_TLIN_CONNECTOR ='layouttemp-tlin-connector'
    static CTLAYOUT_TLIN_CONTENT ='layouttemp-tlin-content'
    static CTLAYOUT_TLIN_MARKER ='layouttemp-tlin-marker'
    static CTLAYOUT_TLIN_OPPOSITE='layouttemp-tlin-opposite'

    static CTLAYOUT_CARD_CONTENT ='layouttemp-card-content'
    static CTLAYOUT_CARD_FOOTER ='layouttemp-card-footer'
    static CTLAYOUT_CARD_HEADER ='layouttemp-card-header'
    static CTLAYOUT_CARD_SUBTITLE ='layouttemp-card-subtitle'
    static CTLAYOUT_CARD_TITLE ='layouttemp-card-title'

    static CTLAYOUT_CRUDTABLE_DETAIL ='layouttemp-crudtbl-detail'
    static CTLAYOUT_CRUDTABLE_HEADER ='layouttemp-crudtbl-header'
    static CTLAYOUT_CRUDTABLE_HEADER_BUTTONS ='layouttemp-crudtbl-headerbtns'
    
    static CTLAYOUT_CRUDTABLE_MENU= 'layouttemp-crudtbl-menu'
    static CTLAYOUT_CRUDTABLE_CUSTOMNEW ='layouttemp-crudtbl-new'    
    

    static CTLAYOUT_MENU_END= 'layouttemp-menu-end'
    static CTLAYOUT_MENU_ITEM= 'layouttemp-menu-item'
    static CTLAYOUT_MENU_ITEMICON= 'layouttemp-menu-itemicon'
    static CTLAYOUT_MENU_START= 'layouttemp-menu-start'
    static CTLAYOUT_MENU_SUBHEADER= 'layouttemp-menu-submheader'
    static CTLAYOUT_TABPANEL_DEFAULT= 'layouttemp-tabpnl-default'
    static CTLAYOUT_TABPANEL_HEADER= 'layouttemp-tabpnl-header'
    static CTLAYOUT_FIELDSET_LEGEND= 'layouttemp-fieldset-legend'
    static CTLAYOUT_DIALOG_HEADER= 'layouttemp-dialog-header'
    static CTLAYOUT_DIALOG_FOOTER= 'layouttemp-dialog-footer'
    static CTLAYOUT_DIALOG_CLOSEICON= 'layouttemp-dialog-closeicon'
    static CTLAYOUT_DIALOG_MAXIMIZEICON= 'layouttemp-dialog-maximizeicon'

    static CTLAYOUT_AUTOCOMPLETE_CONTENT='layouttemp-autocomp-content'
    static CTLAYOUT_AUTOCOMPLETE_EMPTY='layouttemp-autocomp-empty'
    static CTLAYOUT_AUTOCOMPLETE_FOOTER='layouttemp-autocomp-footer'
    static CTLAYOUT_AUTOCOMPLETE_HEADER='layouttemp-autocomp-header'
    static CTLAYOUT_AUTOCOMPLETE_OPTION='layouttemp-autocomp-option'
    static CTLAYOUT_AUTOCOMPLETE_OPTIONGROUP='layouttemp-autocomp-optiongroup'

}